module.exports = __webpack_public_path__ + "static/img/newsgg.10f9d98.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newsgg.png
// module id = gEEk
// module chunks = 45